// tslint:disable:no-console
import * as React from "react";
import { render } from "react-dom";

import { IQualityLevelInfoSchema } from "./types/QualityLevelInfoSchema";
import { AGENT_TYPES, WORK_HONESTLY_MESSAGES } from "./constants";

export interface IOptions {
  qualityLevelInfo?: IQualityLevelInfoSchema | null;
  isAgentPublished?: boolean;
  profileLink?: string;
  agentName?: string;
  isProAgent?: boolean;
  agentType?: string;
  size?: string;
}

export default function initialHonestWork() {
  // tslint:disable-next-line:no-any
  (window as any).renderHonestWork = (
    container: Element,
    options: IOptions = {}
  ) => {
    require.ensure(
      [
        "./components/HonestWorkWrapper/HonestWorkWrapper",
        "./components/WorkHonestlyTooltip/index",
        "./components/Approval/index",
      ],
      () => {
        const HonestWorkWrapper =
          require("./components/HonestWorkWrapper/HonestWorkWrapper").default;

        console.log({ options });

        render(
          <HonestWorkWrapper qualityLevelInfo={options.qualityLevelInfo} />,
          container
        );
      }
    );
  };

  // tslint:disable-next-line:no-any
  (window as any).renderDocsApproval = (
    container: Element,
    agentType: string
  ) => {
    require.ensure(["./components/Approval/index"], () => {
      const { Approval } = require("./components/Approval/index");
      const message = agentType
        ? WORK_HONESTLY_MESSAGES[agentType]
        : WORK_HONESTLY_MESSAGES[AGENT_TYPES.Agent];

      render(<Approval message={message} />, container);
    });
  };
}



// WEBPACK FOOTER //
// ./src/bundles/honest_work/index.tsx